// ============================================================================
// ENGLISH TRANSLATIONS - CHAPTER 3: JESUS CHRIST
// ============================================================================
// Levels 27-39 (13 levels, 39 questions)

export const chapter3Translations = {
  name: "Jesus Christ",
  description: "The Word made flesh... To know Christ is eternal life",
  
  spiritualWisdom: {
    principle: "To know Jesus Christ is eternal life",
    scripture: "Now this is eternal life: that they know you, the only true God, and Jesus Christ, whom you have sent (John 17:3)",
    application: "Every aspect of Jesus' life reveals God and nourishes our soul for eternity"
  },
  
  levels: {
    27: {
      name: "The Annunciation",
      challenge: "The angel Gabriel was sent by God to a city in Galilee...",
      easy: {
        question: "Which angel announced to Mary that she would bear Jesus?",
        options: ["Michael", "Gabriel", "Raphael", "Uriel"],
        hint: "God's messenger angel",
        funFact: "👼 Gabriel means 'Strength of God' - the angel of great announcements!"
      },
      medium: {
        question: "What was Mary's first reaction to this announcement?",
        options: [
          "Immediate joy",
          "Total disbelief",
          "Trouble and the question 'How will this be?'",
          "Fear"
        ],
        hint: "A practical and legitimate question",
        funFact: "🤔 Mary asks a logical question but keeps a heart open to God!"
      },
      hard: {
        question: "What does Mary's submission to God's will teach us?",
        options: [
          "Passivity in the face of trials",
          "Faith that trusts even without understanding everything",
          "Blind obedience",
          "Resignation"
        ],
        hint: "It's about trusting God even in the unknown",
        funFact: "🙏 'Let it be done unto me according to your word' - model of trusting faith!"
      }
    },
    
    28: {
      name: "The Nativity",
      challenge: "She brought forth her firstborn son, wrapped him in swaddling cloths and laid him in a manger...",
      easy: {
        question: "In which city was Jesus born?",
        options: ["Nazareth", "Jerusalem", "Bethlehem", "Capernaum"],
        hint: "The city of David",
        funFact: "🏘️ Bethlehem means 'House of bread' - Jesus, bread of life!"
      },
      medium: {
        question: "Who were the first to receive the announcement of the birth?",
        options: [
          "The wise men",
          "Shepherds in the fields",
          "Temple priests",
          "Mary's family"
        ],
        hint: "Simple people watching their flocks",
        funFact: "🐑 God first announces to humble shepherds - the Gospel for all!"
      },
      hard: {
        question: "What does Jesus born in a manger symbolize?",
        options: [
          "His parents' poverty",
          "God's humility in lowering himself to us",
          "Lack of space",
          "Rural simplicity"
        ],
        hint: "It's about divine incarnation in humility",
        funFact: "👶 The Creator of the universe born in a stable - infinite love!"
      }
    },

    29: {
      name: "The Wise Men from the East",
      challenge: "Wise men from the east came to Jerusalem and asked...",
      easy: {
        question: "What guided the wise men to Jesus?",
        options: ["An angel", "A star", "A vision", "A map"],
        hint: "A celestial body in the sky",
        funFact: "⭐ The star represents that Jesus is the light of the nations!"
      },
      medium: {
        question: "What gifts did the wise men offer?",
        options: [
          "Food",
          "Gold, frankincense and myrrh",
          "Precious clothes",
          "Toys"
        ],
        hint: "Three symbolic and precious gifts",
        funFact: "🎁 Gold (royalty), frankincense (divinity), myrrh (sacrifice) - Jesus' entire mission!"
      },
      hard: {
        question: "What do these pagan wise men represent in God's plan?",
        options: [
          "The superiority of other religions",
          "The universality of salvation offered to all peoples",
          "Material wealth",
          "Ancient science"
        ],
        hint: "It's about opening salvation to all nations",
        funFact: "🌍 The wise men prefigure the Gospel reaching the whole world!"
      }
    },

    30: {
      name: "The Baptism of Jesus",
      challenge: "As soon as Jesus was baptized, he came up out of the water...",
      easy: {
        question: "Who baptized Jesus?",
        options: ["Peter", "John the Baptist", "Andrew", "James"],
        hint: "Jesus' forerunner",
        funFact: "🌊 John the Baptist considered himself unworthy to untie Jesus' sandals!"
      },
      medium: {
        question: "What descended upon Jesus at his baptism?",
        options: [
          "A light",
          "A dove (the Holy Spirit)",
          "An angel",
          "A voice only"
        ],
        hint: "The bird symbolizing peace",
        funFact: "🕊️ The dove reveals divine anointing to begin ministry!"
      },
      hard: {
        question: "Why was Jesus, without sin, baptized?",
        options: [
          "To set an example",
          "To fulfill all righteousness and identify with us",
          "By religious obligation",
          "To receive forgiveness"
        ],
        hint: "It's about solidarity with sinful humanity",
        funFact: "❤️ Jesus identifies completely with us to better save us!"
      }
    },

    31: {
      name: "The Temptation in the Wilderness",
      challenge: "Jesus was led by the Spirit into the wilderness to be tempted by the devil...",
      easy: {
        question: "How long did Jesus fast in the wilderness?",
        options: ["30 days", "40 days", "50 days", "60 days"],
        hint: "The biblical number of trial",
        funFact: "🏜️ Like Moses and Elijah, 40 days of intense spiritual preparation!"
      },
      medium: {
        question: "How did Jesus repel each temptation?",
        options: [
          "By his own strength",
          "By quoting Scripture",
          "By ignoring Satan",
          "By praying only"
        ],
        hint: "The ultimate spiritual weapon",
        funFact: "📖 'It is written...' - God's Word, sword of the Spirit!"
      },
      hard: {
        question: "What does Jesus' temptation teach us about our struggles?",
        options: [
          "Temptations are sin",
          "Temptation can be overcome by Word and faith",
          "We must flee all wilderness",
          "Only Jesus can resist"
        ],
        hint: "It's about our strategy against temptations",
        funFact: "⚔️ Jesus shows us how to overcome: God's Word + active faith!"
      }
    },

    32: {
      name: "The First Disciples",
      challenge: "Jesus said to them: Follow me, and I will make you fishers of men...",
      easy: {
        question: "What was the occupation of Peter and Andrew?",
        options: ["Shepherds", "Fishermen", "Carpenters", "Tax collectors"],
        hint: "A profession of the Sea of Galilee",
        funFact: "🎣 Jesus transforms fishers of fish into fishers of souls!"
      },
      medium: {
        question: "How did the first disciples react to the call?",
        options: [
          "They hesitated for a long time",
          "They asked for proof",
          "They left everything and followed him immediately",
          "They negotiated"
        ],
        hint: "An immediate and total response",
        funFact: "🚶 Jesus' authority was so evident they obeyed instantly!"
      },
      hard: {
        question: "What does 'following Jesus' mean in our era?",
        options: [
          "Abandoning one's job",
          "Living according to his teachings and will",
          "Joining an isolated community",
          "Only doing evangelism"
        ],
        hint: "It's about life transformation and priorities",
        funFact: "✨ Following Jesus transforms our hearts, choices, destiny!"
      }
    },

    33: {
      name: "The Sermon on the Mount",
      challenge: "Blessed are the poor in spirit, for theirs is the kingdom of heaven...",
      easy: {
        question: "With what words do the Beatitudes begin?",
        options: ["Blessed are", "Happy are", "Loved are", "Chosen are"],
        hint: "A word expressing spiritual joy",
        funFact: "😊 'Blessed' reveals that God wants our true happiness!"
      },
      medium: {
        question: "What does Jesus say about those persecuted for righteousness?",
        options: [
          "They will be avenged",
          "Theirs is the kingdom of heaven",
          "They should defend themselves",
          "They are cursed"
        ],
        hint: "The same promise as the first beatitude",
        funFact: "👑 Suffering for righteousness secures the Kingdom's inheritance!"
      },
      hard: {
        question: "How do the Beatitudes revolutionize our values?",
        options: [
          "By promoting poverty",
          "By overturning world values: humility, mercy, justice",
          "By condemning wealth",
          "By isolating believers"
        ],
        hint: "It's about divine values opposed to worldly values",
        funFact: "🔄 The Beatitudes transform our vision of happiness and success!"
      }
    },

    34: {
      name: "The Parables of the Kingdom",
      challenge: "He taught them many things in parables...",
      easy: {
        question: "In the parable of the sower, what does the seed represent?",
        options: [
          "Money",
          "The Word of God",
          "Good works",
          "Love"
        ],
        hint: "What Jesus announces and teaches",
        funFact: "🌱 God's Word germinates and grows in our hearts!"
      },
      medium: {
        question: "In the parable of the mustard seed, what does this small seed symbolize?",
        options: [
          "Human weakness",
          "The Kingdom that starts small but becomes great",
          "The importance of details",
          "Nature"
        ],
        hint: "Something that grows spectacularly",
        funFact: "🌳 From the smallest seed grows a great tree - Kingdom power!"
      },
      hard: {
        question: "Why did Jesus teach in parables?",
        options: [
          "To complicate his message",
          "To reveal spiritual truths through familiar images",
          "For lack of time",
          "To test intelligence"
        ],
        hint: "It's about making Kingdom mysteries accessible",
        funFact: "💡 Parables reveal to open hearts and veil to closed hearts!"
      }
    },

    35: {
      name: "The Miracles of Jesus",
      challenge: "He calmed the wind and said to the sea: Peace! Be still!...",
      easy: {
        question: "With how many loaves did Jesus feed 5000 men?",
        options: ["3 loaves", "5 loaves", "7 loaves", "12 loaves"],
        hint: "The same number as the fish",
        funFact: "🍞 5 loaves and 2 fish become a feast - divine generosity!"
      },
      medium: {
        question: "What did the disciples say when Jesus calmed the storm?",
        options: [
          "He is a magician",
          "Who is this that even wind and sea obey him?",
          "This is normal",
          "We must leave here"
        ],
        hint: "A question about Jesus' identity",
        funFact: "⛈️ Even the elements recognize their Creator and Master!"
      },
      hard: {
        question: "What is the main purpose of Jesus' miracles?",
        options: [
          "To impress crowds",
          "To reveal his divinity and manifest God's love",
          "To gain influence",
          "To help materially only"
        ],
        hint: "It's about divine revelation and compassion",
        funFact: "❤️ Each miracle reveals God's heart: love, compassion, power!"
      }
    },

    36: {
      name: "The Transfiguration",
      challenge: "He was transfigured before them; his face shone like the sun...",
      easy: {
        question: "Which disciples saw Jesus transfigured?",
        options: [
          "All twelve",
          "Peter, James and John",
          "Peter and John only",
          "The women who followed him"
        ],
        hint: "The inner circle of three",
        funFact: "⛰️ Peter, James and John: privileged witnesses of divine glory!"
      },
      medium: {
        question: "Which Old Testament figures appeared?",
        options: [
          "Abraham and Isaac",
          "David and Solomon",
          "Moses and Elijah",
          "Adam and Noah"
        ],
        hint: "The representative of the Law and the Prophets",
        funFact: "📜 Moses (Law) and Elijah (Prophets) bear witness to Jesus!"
      },
      hard: {
        question: "What does this transfiguration reveal about Jesus' nature?",
        options: [
          "He is a great prophet",
          "His hidden divinity manifests temporarily",
          "He controls light",
          "He can change appearance"
        ],
        hint: "It's about revealing his divine nature",
        funFact: "✨ Jesus' divine glory shines through - glimpse of his resurrection!"
      }
    },

    37: {
      name: "The Triumphal Entry",
      challenge: "Hosanna to the Son of David! Blessed is he who comes in the name of the Lord!...",
      easy: {
        question: "On what animal did Jesus enter Jerusalem?",
        options: ["A horse", "A donkey", "A camel", "On foot"],
        hint: "An animal symbolizing humility and peace",
        funFact: "🐴 The donkey symbolizes the humble King who comes in peace, not war!"
      },
      medium: {
        question: "What did the crowd shout while acclaiming Jesus?",
        options: [
          "Long live the King!",
          "Hosanna! Blessed is he who comes in the name of the Lord!",
          "Glory to God!",
          "Freedom!"
        ],
        hint: "A cry of joy and blessing",
        funFact: "🌿 'Hosanna' means 'Save now' - call for divine salvation!"
      },
      hard: {
        question: "Why is this entry 'triumphal' but tragic?",
        options: [
          "There were few people",
          "The crowd that acclaims him will reject him in 5 days",
          "The authorities were absent",
          "It was raining"
        ],
        hint: "It's about the fickleness of the human heart",
        funFact: "💔 The same crowd will cry 'Crucify him!' a few days later!"
      }
    },

    38: {
      name: "The Last Supper",
      challenge: "Take and eat, this is my body which is given for you...",
      easy: {
        question: "What did Jesus do to his disciples' feet?",
        options: [
          "He blessed them",
          "He washed them",
          "He anointed them",
          "He kissed them"
        ],
        hint: "A gesture of humility and service",
        funFact: "🦶 The Master becomes servant - revolution of love and humility!"
      },
      medium: {
        question: "What did Jesus institute during this meal?",
        options: [
          "Baptism",
          "Communion (Lord's Supper)",
          "The Lord's Prayer",
          "Fasting"
        ],
        hint: "A sacrament with bread and wine",
        funFact: "🍞🍷 Bread and wine become eternal symbols of sacrifice and love!"
      },
      hard: {
        question: "What does 'Do this in remembrance of me' mean?",
        options: [
          "Repeat this meal",
          "Celebrate my death and resurrection until my return",
          "Remember my words",
          "Love one another"
        ],
        hint: "It's about a living and prophetic commemoration",
        funFact: "⏳ Each communion proclaims the Lord's death until he comes!"
      }
    },

    39: {
      name: "Gethsemane",
      challenge: "My Father, if it is possible, let this cup pass from me...",
      easy: {
        question: "Where did Jesus pray before his arrest?",
        options: [
          "In the Temple",
          "In the Garden of Gethsemane",
          "On the Mount of Olives",
          "At friends' house"
        ],
        hint: "A garden with olive trees",
        funFact: "🫒 Gethsemane means 'oil press' - place of intense pressure!"
      },
      medium: {
        question: "What did the disciples do while Jesus prayed?",
        options: [
          "They prayed with him",
          "They fell asleep",
          "They stood guard",
          "They left"
        ],
        hint: "They could not watch one hour",
        funFact: "😴 The spirit is willing but the flesh is weak - human weakness!"
      },
      hard: {
        question: "What does Jesus' agony reveal about his nature?",
        options: [
          "He was only man",
          "He was fully man AND fully God",
          "He doubted his mission",
          "He was weak"
        ],
        hint: "It's about the mystery of incarnation",
        funFact: "✝️ Jesus fully assumes human anguish while remaining faithful to God!"
      }
    }
  }
};

export default chapter3Translations;